/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

export const SHOW_SHIPPING_INFO = 'SHOW_SHIPPING_INFO';
export const UPDATE_SHOW_SHIPPING_INFO = 'UPDATE_SHOW_SHIPPING_INFO';
